import { ScrollArea as RadixScrollArea } from "@radix-ui/themes";
import "./styles.css";
export const ScrollArea = RadixScrollArea;
